import React from "react"

import {FieldGoalListViewProps} from "../../../../render/goal-list/goal-list-view"
import FieldStatus_InlineValueNotEmpty from "../../../../generic/status/components/inline-edit/value-not-empty"

export default function FieldEventStatus_GoalListView(props:FieldGoalListViewProps) {

    const value = props.model[props.field.fieldId]

    const option = props.field._getOption(value)
    const configOptions = _.get(props, 'configOptions', {})
    if (!configOptions.renderType) {
        configOptions.renderType = 'ui5'
    }

    return <FieldStatus_InlineValueNotEmpty className       = {props.className}
                                            field           = {props.field}
                                            option          = {option}
                                            configOptions   = {configOptions}/>

}